<template>
    <!--
        Intestazione scritta a mano al posto dei componenti `CHeader*`. Le classi restano quelle di
        CoreUI 3, gia fornite dal foglio di stile in progetto.

        Le due tendine passano da `el-dropdown` di element-plus: erano l'unico punto in cui serviva un
        **comportamento** e non solo un contenitore, e la libreria e gia in progetto.
    -->
    <header class="c-header c-header-fixed c-header-light">
        <button
            type="button"
            class="c-header-toggler c-class-toggler d-lg-none"
            @click="$store.commit('toggleSidebarMobile')"
        >
            <span class="c-header-toggler-icon"></span>
        </button>

        <RouterLink to="/" class="c-header-brand ml-auto mr-2 d-lg-none">
            <font-awesome-icon icon="home" size="2x" />
        </RouterLink>

        <ul class="c-header-nav ml-auto mr-4">
            <li class="c-header-nav-item">
                <span class="fs-14 mr-2">{{ userName }}</span>
            </li>

            <li v-if="isAdmin" class="c-header-nav-item mx-2">
                <ElDropdown placement="bottom-end" trigger="click">
                    <span class="c-header-nav-link">
                        <font-awesome-icon icon="cog" />
                    </span>
                    <template #dropdown>
                        <ElDropdownMenu>
                            <ElDropdownItem disabled>
                                <strong>{{ $t('preferences') }}</strong>
                            </ElDropdownItem>
                            <ElDropdownItem @click="$router.push({ name: 'page-settings' })">
                                <font-awesome-icon icon="sliders-h" class="mr-3" />
                                <span class="mr-2">{{ $t('settings') }}</span>
                            </ElDropdownItem>
                        </ElDropdownMenu>
                    </template>
                </ElDropdown>
            </li>

            <li class="c-header-nav-item mx-2">
                <TheHeaderDropdownAccnt />
            </li>
        </ul>
    </header>
</template>

<script lang="ts" src="./TheHeader.ts"></script>
